
import api, { apiInternal } from '../api';


export async function getAllContracts() {
  const { data } = await api.post(`${apiInternal}/getContracts`,{});
  return data;
}

export async function getContractById(contId) {
  const { data } = await api.post(`${apiInternal}/getContract`, { cont_id: contId });
  return data;
}
export async function removeEstablishments( params) {
  const { data } = await api.post(`${apiInternal}/dissociateEstablishmentsFromContract`, params);
  return data;    
}
export async function setEstablishments( params) {
  const { data } = await api.post(`${apiInternal}/setEstablishmentsToContract`, params);
  return data;    
}
export async function setContractEnd( contId, date_end) {
  const { data } = await api.post(`${apiInternal}/setContractEnd`, { cont_id: contId, cont_date_end: date_end });
  return data;
}